import React from 'react'
import Carousel from "../../components/Home/Carousel/Carousel";
import AboutUs from "./AboutUs/AboutUs";
import OurBrands from "./OurBrands/OurBrands";
import Inspiration from "./Inspiration/Inspiration";
import Social from "./Social/Social";
import styles from './Home.module.css'

function Home(){
    return (
        <div className={styles['home']}>
            <Carousel/>
            <AboutUs/>
            <OurBrands/>
            <Inspiration/>
            <Social/>
        </div>
    )
}

export default Home